import React, {useEffect} from 'react'
import {useGraphRelationContext} from "../services/ButtonRelationService";
import colors from "../../../../../../../utils/Colors";
import Point from "../structures/Point";
import config from "../../../config";

const ButtonConnectorLine = ({gRef, removeButtonConnection, edges}) => {

    const {
        startPoint,
        activeButtonId,
        endPoint,
        setEndPoint,
        setActiveButtonId,
        setStartPoint,
        setGraphMoveDirection,
        setGraphMoveSpeedMultiplayer
    } = useGraphRelationContext()

    useEffect(() => {
        const handleMouseMove = (event) => {
            const svg = gRef.current.ownerSVGElement;
            const pt = svg.createSVGPoint();

            pt.x = event.clientX + 5;
            pt.y = event.clientY;

            const transformed = pt.matrixTransform(
                gRef.current.getScreenCTM().inverse()
            );

            setEndPoint(new Point(transformed.x, transformed.y));

            const rect = svg.getBoundingClientRect();
            const trigger = config.graphMoveTriggerArea;

            const x = event.clientX - rect.left;
            const y = event.clientY - rect.top;

            let direction = null;
            let speedMultiplier = 0;

            if (y < trigger) {
                direction = 'top';
                speedMultiplier = 1 - (y / trigger);
            } else if (rect.height - y < trigger) {
                direction = 'bottom';
                speedMultiplier = 1 - ((rect.height - y) / trigger);
            } else if (x < trigger) {
                direction = 'left';
                speedMultiplier = 1 - (x / trigger);
            } else if (rect.width - x < trigger) {
                direction = 'right';
                speedMultiplier = 1 - ((rect.width - x) / trigger);
            }

            speedMultiplier = Math.max(0, Math.min(speedMultiplier, 1));

            setGraphMoveDirection(direction);
            setGraphMoveSpeedMultiplayer(speedMultiplier);
        };


        if (activeButtonId && gRef.current) {
            window.addEventListener('mousemove', handleMouseMove)
        }

        return () => {
            if (gRef.current) {
                window.removeEventListener('mousemove', handleMouseMove)
            }
        }
    }, [activeButtonId])

    useEffect(() => {
        const handleMouseUp = (event) => {
            if (!activeButtonId) return;
            if (edges.some(edge => edge.buttonId === activeButtonId)) {
                removeButtonConnection(activeButtonId);
            }

            setActiveButtonId(null);
            setEndPoint(null);
            setStartPoint(null);
        }

        window.addEventListener('mouseup', handleMouseUp)

        return () => {
            window.removeEventListener('mouseup', handleMouseUp)
        }
    }, [activeButtonId])

    if (activeButtonId === null) return null

    return (
        <line
            style={{color: colors.silverBlue}} stroke="currentColor"
            x1={startPoint.x}
            y1={startPoint.y}
            x2={endPoint.x}
            y2={endPoint.y}
        />
    )
}

export default ButtonConnectorLine


// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/containers/GraphView/components/ButtonConnectorLine.jsx